enum AuthButtonsType {
  GetStarted = 'GET_STARTED',
  LoginSignup = 'LOGIN_SIGNUP',
}

export { AuthButtonsType };
